import { useMutation, useQueryClient } from "@tanstack/react-query";

import { tillsKeys } from "../../tills/keys";
import { createSession } from "../requests";
import { sessionsKeys } from "../keys";

export function useOpenSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createSession,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: tillsKeys.details()
      });
      await queryClient.invalidateQueries({
        queryKey: tillsKeys.lists()
      });
      await queryClient.invalidateQueries({
        queryKey: sessionsKeys.lists()
      });
      await queryClient.invalidateQueries({
        queryKey: sessionsKeys.details()
      });
    }
  });
}
